// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__uFp9T","headline":"Accordion_headline__4eICK","closed":"Accordion_closed__KaCrr","chevron":"Accordion_chevron__X0uH1"};